import * as React from 'react';
import * as FontAwesome from 'react-fontawesome';
import { connect, Dispatch } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as shortId from 'shortid';
import { ApplicationState } from '../../data/applicationStates';
import { headerActionCreators } from '../../data/header/headerActions';
import { HeaderState } from '../../data/header/headerModels';
import { orderActionCreators } from '../../data/order/orderActions';
import { ApiOrderState } from '../../data/order/orderModels';
import './orders.css';
// tslint:disable-next-line:no-var-requires
const moment = require('moment');
// var moment = require('moment/locale/en-gb');
// tslint:disable-next-line:no-var-requires
const orders = require('../../resources/orders.png');
import Table from '../../components/table/table';
import { DataType, RowObject, Tbody } from '../../components/table/tableModels';

interface OrdersState {
    order: ApiOrderState;
    header: HeaderState;
}

interface OrdersActions {
    orderActions: typeof orderActionCreators;
    headerActions: typeof headerActionCreators;
}

type OrdersProps = OrdersState & // ... state we've requested from the Redux store
    OrdersActions & // ... plus action creators we've requested
    RouteComponentProps<{}>; // ... plus incoming routing parameters

interface State {
    tHead: Array<RowObject>;
    orderList: Array<Tbody>;
}

class Orders extends React.Component<OrdersProps, State> {
    constructor(props: OrdersProps) {
        super(props);
        this.renderOrders = this.renderOrders.bind(this);
        this.state = {
            tHead: [
                new RowObject(DataType.string, 'Order Date', undefined, undefined, 'pointer'),
                new RowObject(DataType.string, 'Purchase Order', undefined, undefined, 'pointer'),
                new RowObject(DataType.string, 'Order Number', undefined, undefined, 'pointer'),
                new RowObject(DataType.string, 'Ship To Name', undefined, undefined, 'pointer'),
                new RowObject(DataType.string, 'Estimated Ship Date', undefined, undefined, 'pointer')
            ],
            orderList: []
        };
    }

    componentWillMount() {
        this.props.headerActions.setBottomHeader('My Quick Solutions Online');
        this.getTbody(this.props);
    }

    componentDidUpdate(prevProps: OrdersProps) {
        if (this.props.order.orders !== prevProps.order.orders) {
            this.getTbody(this.props);
        }
    }

    renderOrders() {
        const arr = Array<any>();

        for (const x of this.props.order.orders) {
            arr.push(<div key={shortId.generate()}>{x.shippingName}</div>);
        }
        return arr;
    }

    getOrder(orderId: string) {
        this.props.history.push('/order/' + orderId);
    }

    getTbody(props: OrdersProps) {
        let OrderList = new Array<Tbody>();

        OrderList = props.order.orders.map((data) => {
            const rBody = new Array<RowObject>();

            rBody.push(
                new RowObject(
                    DataType.string,
                    data.orderDate ? moment(data.orderDate, 'M/D/YYYY').format('M/D/YYYY') : '',
                    null,
                    undefined,
                    undefined
                )
            );

            rBody.push(
                new RowObject(DataType.string, data.purchaseOrder ? data.purchaseOrder : '', null, undefined, undefined)
            );

            rBody.push(
                new RowObject(DataType.string, data.orderNumber ? data.orderNumber : '', null, undefined, undefined)
            );

            rBody.push(
                new RowObject(DataType.string, data.shippingName ? data.shippingName : '', null, undefined, undefined)
            );

            rBody.push(
                new RowObject(
                    DataType.string,
                    data.estimatedShipDate ? moment(data.estimatedShipDate, 'M/D/YYYY').format('M/D/YYYY') : '',
                    null,
                    undefined,
                    undefined
                )
            );
            const row = new Tbody(rBody, data.orderId, this.getOrder.bind(this));

            return row;
        });
        this.setState({ orderList: OrderList });
    }

    public render() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="componentHeader">
                        <div className="item tile">
                            <div className="tileHead">
                                <div className="float-left">
                                    <h4>{'Orders'}</h4>
                                </div>
                                <div className="tileImage float-right">{<img src={orders} />}</div>
                            </div>
                            <div className="tileBody">
                                <div className="topBorder" />
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.orderList.length > 0 ? (
                    <Table
                        tHead={this.state.tHead}
                        tBody={this.state.orderList}
                        listSize={this.props.order.orders.length}
                        hover={true}
                        cursor={true}
                        hidePagination={true}
                        americanDateFormat={true}
                    />
                ) : (
                    <div className="centerThis">
                        <FontAwesome className="progressicon" name="spinner" size="3x" spin={true} />
                    </div>
                )}
            </div>
        );
    }
}

export function mapStateToProps(state: ApplicationState): OrdersState {
    return {
        order: state.order,
        header: state.header
    };
}

function mapDispatchToProps(dispatch: Dispatch<{}>): OrdersActions {
    return {
        orderActions: bindActionCreators(orderActionCreators, dispatch),
        headerActions: bindActionCreators(headerActionCreators, dispatch)
    };
}

export default withRouter(
    connect(
        mapStateToProps, // Selects which state properties are merged into the component's props
        mapDispatchToProps // Selects which action creators are merged into the component's props
    )(Orders)
);



// WEBPACK FOOTER //
// ./src/containers/orders/orders.tsx